import React from "react";
import PropTypes from "prop-types";
import { SimpleSelect } from "components/ui/simple-select";
import Label from "../Form/Label";

const Dropdown = ({
  label,
  flex,
  marginLeft,
  marginBottom,
  isRequired,
  options,
  onChange,
  onBlur,
  description,
  placeholder,
  isClearable,
  showInsidePopup,
  menuPlacement,
  value,
  defaultValue,
  error,
}) => (
  <div
    className="textinput-core-container"
    style={{ flex: flex, marginLeft: marginLeft, marginBottom: marginBottom }}
  >
    {label && <Label>{label}</Label>}
    <SimpleSelect
      value={value || defaultValue}
      onChange={onChange}
      onBlur={onBlur}
      options={options}
      placeholder={placeholder}
      disabled={false}
      isMulti={false}
      isClearable={isClearable}
      className={error || isRequired ? "border-system-red" : ""}
    />
    {description && !error ? (
      <label className="textinput-core-label textinput-core-description">
        {description}
      </label>
    ) : error ? (
      <label className="text-red-500 text-sm block mt-1">{error}</label>
    ) : null}
  </div>
);

Dropdown.propTypes = {
  showInsidePopup: PropTypes.bool,
  placeholder: PropTypes.string,
};

Dropdown.defaultProps = {
  showInsidePopup: false,
  placeholder: "",
};

export default Dropdown;
